module.exports = __webpack_public_path__ + "static/media/nineteenth_robert_n_stewart_bridge.91ce1d92.mp4";